import { useAtomValue } from "jotai";
import { useState } from "react";

import { Line } from "@sorcery/ui";

import { CardSquiggly } from "~/components/molecules/card/CardSquiggly";
import { Stats } from "~/components/molecules/deck/Stats";
import { Decklist } from "~/components/organisms/deck/decklist/Decklist";
import { PreconToolbar } from "~/pages/precons/[deckId]/PreconToolbar";
import { avatarJotai } from "~/state/deckJotai";
import type { CardType, VariantType } from "~/types/card";

export const BodyContent = () => {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const avatar = useAtomValue(avatarJotai)!;
  const [squiggleCard, setSquiggleCard] = useState<{
    card: CardType;
    variant: VariantType;
  }>({
    card: avatar.card,
    variant: avatar.variant,
  });

  return (
    <>
      <div className="animate-in fade-in">
        <div className="mb-8 flex flex-row">
          {/* Deck */}
          <div className="relative grow">
            <div className="mb-4">
              <PreconToolbar />
            </div>

            {/* Decklist */}
            <Decklist onCardHover={setSquiggleCard} size={"lg"} />
          </div>
          <div className="hidden pl-6 md:block">
            <CardSquiggly card={squiggleCard.card} variant={squiggleCard.variant} />
          </div>
        </div>

        <Line className="mb-8" />

        {/* Stats */}
        <Stats />
      </div>
    </>
  );
};
